(() => {
  if (customElements.get('yhf-footer-navigation')) return;
  customElements.define('yhf-footer-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const groups = [...this.querySelectorAll('[data-footer-group]')];
      const mobile = matchMedia('(max-width: 699px)');
      const sync = () => groups.forEach(group => {
        const summary = group.querySelector('summary');
        if (mobile.matches) {
          if (group.contains(document.activeElement) && document.activeElement !== summary) summary.focus({ preventScroll: true });
          group.open = false;
          summary.removeAttribute('tabindex');
          summary.removeAttribute('aria-disabled');
        } else {
          group.open = true;
          summary.setAttribute('tabindex', '-1');
          summary.setAttribute('aria-disabled', 'true');
        }
      });
      groups.forEach(group => {
        group.querySelector('summary').addEventListener('click', event => {
          if (!mobile.matches) event.preventDefault();
        }, options);
        group.addEventListener('toggle', () => {
          if (mobile.matches && group.open) groups.forEach(other => { if (other !== group) other.open = false; });
        }, options);
      });
      mobile.addEventListener('change', sync, options);
      sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
